// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-2OJ9a";
var _4 = "wrapper_arrowed-1iNCK";
var _5 = "header-34rFP";
var _6 = "icon-36Ybb";
var _7 = "body-1GC6L";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "wrapper_arrowed", _5 as "header", _6 as "icon", _7 as "body" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "wrapper_arrowed": _4, "header": _5, "icon": _6, "body": _7 }
